export default __webpack_public_path__ + "static/media/map.0c810115.jpg";